import {v4 as UUIDv4} from "uuid";
import {BizFormQuestionTypeIds} from "../../../index";


/**
 * The Utils class for the BizForm
 */
class BizFormUtils {

    /**
     * Formats the bytes into a human-readable format.
     * @param bytes        The bytes to format.
     * @returns            The formatted bytes.
     */
    static formatBytes(bytes: number): string {
        if (bytes === 0)
            return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    /**
     * Reorders the entities based on the new order index of the entity to move.
     *
     * @param list              The list of entities to reorder.
     * @param oldIndex          The old index of the entity to move.
     * @param newIndex          The new index of the entity to move.
     * @param orderIndexKey     The key of the order index property of the entity.
     */
    static reorderList<T extends object>(list: T[], oldIndex: number, newIndex: number, orderIndexKey?: keyof T): T[] {
        let entities = Array.from(list);

        if (oldIndex < 0 || oldIndex >= entities.length || newIndex < 0 || newIndex >= entities.length) {
            throw new Error("Invalid indices");
        }

        const [movedElement] = entities.splice(oldIndex, 1); // Remove the element from the old index
        entities.splice(newIndex, 0, movedElement); // Insert the element at the new index

        if (orderIndexKey) {
            entities = entities.map((entity, index) => {
                entity[orderIndexKey] = index as T[keyof T]
                return entity;
            });
        }

        return entities;
    }

    /**
     * Generates a unique id for the query builder
     */
    static createUUID() {
        const uuid = UUIDv4();
        return `BizForm_${uuid}`
    }

    /**
     * Whether to show the options field
     */
    static showQuestionOptions(typeId: number) {
        return [
            BizFormQuestionTypeIds.select,
            BizFormQuestionTypeIds.multiSelect,
            BizFormQuestionTypeIds.trueFalse
        ].includes(Number(typeId))
    }
}

export default BizFormUtils;
